<template lang="pug">
.usuarios.container.grid-lg.py-2
  loading.v-loading(:loading='loading')
  .usuario
    .card(v-if='current')
      .card-header
        .card-title
          h4 {{ current.descricao }}
      .card-body(v-if='perfil')
        .form-group
          label.form-label(for='descricao') {{ "perfil.descricao" | tModel }}
          input#descricao.form-input(type='text', v-model='perfil.descricao')
        .form-group
          label.form-switch
            input(type='checkbox', v-model='perfil.ativo')
            i.form-icon
            |
            | {{ "perfil.ativo" | tModel }}
        .form-group(v-if='tree && tree.permissoes')
          label.form-label {{ "perfil.permissoes" | tModel }}
          .has-icon-left.has-reset-input(
            style='max-width: 400px',
            :class='{ "input-not-empty": query }'
          )
            input#query.form-input.input-sm(
              type='search',
              v-model='query',
              placeholder='Pesquisar',
              autocomplete='off'
            )
          .text-right(style='padding-right: 20px')
            a.btn.btn-link.tooltip.tooltip-bottom(
              @click='toggle(true)',
              data-tooltip='Expandir'
            )
              i.fa.fa-lg.fa-plus-circle.primary
            a.btn.btn-link.tooltip.tooltip-bottom(
              @click='toggle(false)',
              data-tooltip='Recolher'
            )
              i.fa.fa-lg.fa-minus-circle.primary
          permissoes(
            :permissoes='tree.permissoes',
            :query='query'
          )
      .card-footer.text-right
        btn-logs(entityName='Perfil', :entityId='current.id' v-acl:allowed.admin.logs.index)
        router-link.primary.btn.btn-link(:to='{ name: "app.sistema.perfis" }')
          btn-content(name='list')
        button.btn.btn-primary(
          :class='{ loading: loading }',
          @click='save',
          :disabled='loading'
        )
          btn-content(name='save')
</template>

<script>
import Perfil from '@/models/Perfil'
import Permissao from '@/models/Permissao'

export default {
  vuex: {
    'sistema/perfis': {
      state: ['current', 'todasAsPermissoes'],
      actions: ['fetchOne', 'fetchUpdate', 'fetchTodasAsPermissoes'],
      getters: ['loading'],
    },
  },
  data() {
    return { perfil: null, tree: null, query: '' }
  },
  methods: {
    toggle(value) {
      if (this.tree) {
        this.tree.toggleAll(value)
      }
    },

    setPerfil() {
      this.perfil = new Perfil(this.current)
      this.setTree()
    },
    setTree() {
      if (!this.tree && this.todasAsPermissoes && this.perfil) {
        this.tree = new Permissao(
          this.todasAsPermissoes,
          this.perfil.permissoes,
        )
      }
    },
    save() {
      this.perfil.permissoes = this.tree.json
      this.fetchUpdate(this.perfil)
        .then(res => {
          this.$toaster.success('Salvo com sucesso.')
        })
        .catch(e => {
          this.$toaster.error(this.$parseErrors(e).join(', '))
        })
    },

    async loadData() {
      await this.fetchOne(this.$route.params.id)
      await this.fetchTodasAsPermissoes()
      this.setPerfil()
    },
  },

  created() {
    this.loadData()
  },
}
</script>
